function changeDateOrder(dateString) {
    const dateParts = dateString.split("/");
    if (3 === dateParts.length) return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
    console.log("Invalid date format");
}
function extractBookingData(dataCSV) {
    const dataArray = dataCSV.split(",");
    return { startDate: dataArray[0], location: dataArray[1], reference: dataArray[2], guests: dataArray[3], numberOfDays: dataArray[4], cutoff: dataArray[5], locationCode: dataArray[6].toLowerCase() };
}
function handleSubmit(event) {
    event.preventDefault();
    let searchData = {};
    (searchData.booking_ref = document.querySelector('input[name="bookingReference"]').value.trim().toUpperCase()),
        (searchData.departure_date = document.querySelector('input[name="departureDate"]').value),
        searchBookings(searchData.booking_ref, searchData.departure_date);
}
function addOrder(startDate, location, reference, guests, numberOfDays, cutoff, locationCode) {
     let safeRefClass = reference.replace(/\s+/g, '-');
    let orderContainer = document.querySelector("#existing-bookings-container"),
        orderDiv = document.createElement("div");
    orderDiv.classList.add("customer-order");
    orderDiv.setAttribute("data-reference", safeRefClass);
    let headingContainer = document.createElement("div");
      let deleteButton = document.createElement("button");

deleteButton.classList.add("delete-booking");

deleteButton.innerHTML = `<span class="trash-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M262.2 48C248.9 48 236.9 56.3 232.2 68.8L216 112L120 112C106.7 112 96 122.7 96 136C96 149.3 106.7 160 120 160L520 160C533.3 160 544 149.3 544 136C544 122.7 533.3 112 520 112L424 112L407.8 68.8C403.1 56.3 391.2 48 377.8 48L262.2 48zM128 208L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 208L464 208L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 208L128 208zM288 280C288 266.7 277.3 256 264 256C250.7 256 240 266.7 240 280L240 456C240 469.3 250.7 480 264 480C277.3 480 288 469.3 288 456L288 280zM400 280C400 266.7 389.3 256 376 256C362.7 256 352 266.7 352 280L352 456C352 469.3 362.7 480 376 480C389.3 480 400 469.3 400 456L400 280z"/></svg></span>
    <span>Remove</span>`;
    headingContainer.classList.add("heading-container");
    const reorderedStartDate = changeDateOrder(startDate);
    let daysToGo = Math.ceil((new Date(reorderedStartDate) - new Date()) / 864e5),
        daysToGoElement = document.createElement("span");
    daysToGoElement.classList.add("days-to-go"),
        "number" != typeof daysToGo ||
            isNaN(daysToGo) ||
            (daysToGo > 0 && (daysToGoElement.textContent = `${daysToGo} days to go`),
            daysToGo < 0 && ((daysToGo *= -1), (daysToGoElement.textContent = `${daysToGo} days since your trip`)),
            0 == daysToGo && (daysToGoElement.textContent = "Today is the day!"));
        let locationContainerElement = document.createElement("div");
    locationContainerElement.classList.add("location-wrapper");
    let locationElement = document.createElement("span");
    locationElement.classList.add("location"),
        (locationElement.textContent = `${location}`),
        (locationContainerElement.innerHTML +=
            '<svg xmlns="http://www.w3.org/2000/svg" style="width: 18px; height:18px;" width="18" height="18" style="width: 18px;height: 18px;" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.67012C7.4529 1.67012 5.96917 2.28597 4.87521 3.3822C3.78125 4.47842 3.16667 5.96523 3.16667 7.51553C3.16667 9.77784 4.63811 11.9866 6.27163 13.7145C7.07134 14.5604 7.87389 15.2532 8.47744 15.7348C8.67648 15.8936 8.85314 16.0289 9 16.1385C9.14686 16.0289 9.32352 15.8936 9.52256 15.7348C10.1261 15.2532 10.9287 14.5604 11.7284 13.7145C13.3619 11.9866 14.8333 9.77784 14.8333 7.51553C14.8333 5.96523 14.2188 4.47842 13.1248 3.3822C12.0308 2.28597 10.5471 1.67012 9 1.67012ZM9 17.1651C8.53775 17.8599 8.53754 17.8598 8.53731 17.8596L8.53507 17.8581L8.52997 17.8547L8.51266 17.8429C8.49801 17.833 8.4772 17.8187 8.45066 17.8003C8.39757 17.7634 8.32147 17.7099 8.22563 17.6405C8.03405 17.5019 7.76311 17.2997 7.43923 17.0413C6.79278 16.5254 5.92866 15.7801 5.06171 14.8631C3.36189 13.0651 1.5 10.4491 1.5 7.51553C1.5 5.52228 2.29018 3.61068 3.6967 2.20125C5.10322 0.791812 7.01088 0 9 0C10.9891 0 12.8968 0.791812 14.3033 2.20125C15.7098 3.61068 16.5 5.52228 16.5 7.51553C16.5 10.4491 14.6381 13.0651 12.9383 14.8631C12.0713 15.7801 11.2072 16.5254 10.5608 17.0413C10.2369 17.2997 9.96595 17.5019 9.77437 17.6405C9.67853 17.7099 9.60243 17.7634 9.54934 17.8003C9.5228 17.8187 9.50199 17.833 9.48734 17.8429L9.47003 17.8547L9.46493 17.8581L9.46329 17.8592C9.46305 17.8594 9.46225 17.8599 9 17.1651ZM9 17.1651L9.46225 17.8599C9.18233 18.0469 8.81722 18.0466 8.53731 17.8596L9 17.1651Z" fill="#1C2021"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 6.12376C8.23294 6.12376 7.61111 6.74688 7.61111 7.51553C7.61111 8.28418 8.23294 8.90729 9 8.90729C9.76706 8.90729 10.3889 8.28418 10.3889 7.51553C10.3889 6.74688 9.76706 6.12376 9 6.12376ZM5.94444 7.51553C5.94444 5.8245 7.31246 4.45365 9 4.45365C10.6875 4.45365 12.0556 5.8245 12.0556 7.51553C12.0556 9.20656 10.6875 10.5774 9 10.5774C7.31246 10.5774 5.94444 9.20656 5.94444 7.51553Z" fill="#1C2021"/></svg>'),
        locationContainerElement.appendChild(locationElement),
               headingContainer.appendChild(deleteButton);
        headingContainer.style.display = "flex";
headingContainer.style.alignItems = "center";
headingContainer.style.justifyContent = "space-between";
        orderDiv.appendChild(headingContainer);
         orderDiv.appendChild(locationContainerElement);
    let bookingInformationContainer = document.createElement("div");
    bookingInformationContainer.classList.add("middle-container");
    let bookingRefContainerElement = document.createElement("div");
    bookingRefContainerElement.classList.add("booking-information-item");
    let bookingRefDetailsContainer = document.createElement("div");
    bookingRefDetailsContainer.classList.add("booking-information-details");
    let bookingRefElement = document.createElement("span");
    bookingRefElement.classList.add("booking-reference"), (bookingRefElement.textContent = `${reference}`);
    (bookingRefDetailsContainer.innerHTML +=
        '<svg style="width: 18px; height:18px;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="PushPin"><path id="Vector" d="M6.1875 11.8125L3.375 14.625" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M10.8497 2.08968L6.4692 6.47015C6.4692 6.47015 4.52155 5.49281 2.43326 7.18031C2.37182 7.23004 2.32154 7.29215 2.28571 7.36262C2.24988 7.43308 2.2293 7.5103 2.22532 7.58925C2.22134 7.6682 2.23405 7.7471 2.26261 7.8208C2.29117 7.89451 2.33494 7.96137 2.39108 8.01703L9.97076 15.5967C10.0275 15.6544 10.096 15.6993 10.1717 15.7281C10.2473 15.7569 10.3283 15.769 10.4091 15.7637C10.4898 15.7584 10.5685 15.7357 10.6397 15.6971C10.7109 15.6586 10.7729 15.6052 10.8215 15.5405C11.4122 14.76 12.3403 13.1428 11.5317 11.5327L15.9122 7.15218C15.9653 7.09984 16.0075 7.03746 16.0363 6.96865C16.0651 6.89984 16.08 6.826 16.08 6.7514C16.08 6.67681 16.0651 6.60296 16.0363 6.53416C16.0075 6.46535 15.9653 6.40296 15.9122 6.35062L11.6512 2.08968C11.5989 2.03654 11.5365 1.99433 11.4677 1.96552C11.3989 1.93671 11.325 1.92188 11.2505 1.92188C11.1759 1.92188 11.102 1.93671 11.0332 1.96552C10.9644 1.99433 10.902 2.03654 10.8497 2.08968Z" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></g></svg>'),
        (bookingRefDetailsContainer.innerHTML += '<span class="title">Booking reference:</span>'),
        bookingRefContainerElement.appendChild(bookingRefDetailsContainer),
        bookingRefContainerElement.appendChild(bookingRefElement);
    let guestsContainerElement = document.createElement("div");
    guestsContainerElement.classList.add("booking-information-item");
    let guestsDetailsContainer = document.createElement("div");
    guestsDetailsContainer.classList.add("booking-information-details");
    let guestsTitleElement = document.createElement("span");
    guestsTitleElement.classList.add("title"), (guestsTitleElement.textContent = "Guests:");
    let guestsElement = document.createElement("span");
    guestsElement.classList.add("guests"), (guestsElement.textContent = `${guests} Guests`);
    (guestsDetailsContainer.innerHTML +=
        '<svg xmlns="http://www.w3.org/2000/svg" style="width: 18px; height:18px;" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M15 15.75V14.25C15 13.4544 14.6839 12.6913 14.1213 12.1287C13.5587 11.5661 12.7957 11.25 12 11.25H6C5.20435 11.25 4.44129 11.5661 3.87868 12.1287C3.31607 12.6913 3 13.4544 3 14.25V15.75" fill="none" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z" fill="none" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'),
        guestsDetailsContainer.appendChild(guestsTitleElement),
        guestsContainerElement.appendChild(guestsDetailsContainer),
        guestsContainerElement.appendChild(guestsElement);
    let durationContainerElement = document.createElement("div");
    durationContainerElement.classList.add("booking-information-item");
    let durationDetailsContainer = document.createElement("div");
    durationDetailsContainer.classList.add("booking-information-details");
    let durationTitleElement = document.createElement("span");
    durationTitleElement.classList.add("title"), (durationTitleElement.textContent = "Duration:");
    let durationElement = document.createElement("span");
    durationElement.classList.add("duration");
    let endDate = calculateEndDate(startDate, numberOfDays);
    durationElement.textContent = `${formatDate(reorderedStartDate)} to ${formatDate(changeDateOrder(endDate))}`;
    (durationDetailsContainer.innerHTML +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" style="width: 18px; height:18px;">\n    <path fill="none" d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n    <path fill="none" d="M12 1.5V4.5" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n    <path fill="none" d="M6 1.5V4.5" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n    <path fill="none" d="M2.25 7.5H15.75" stroke="#1C2021" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n    </svg>'),
        durationDetailsContainer.appendChild(durationTitleElement),
        durationContainerElement.appendChild(durationDetailsContainer),
        durationContainerElement.appendChild(durationElement),
        bookingInformationContainer.appendChild(bookingRefContainerElement),
        bookingInformationContainer.appendChild(guestsContainerElement),
        bookingInformationContainer.appendChild(durationContainerElement),
        orderDiv.appendChild(bookingInformationContainer);
    let overrideDate = "",
        adjustedCutoff = cutoff;
    const { customerTags } = window.travelopia;
    customerTags.forEach((tag) => {
        tag.includes("Extend:") &&
            tag.includes(reference) &&
            ((overrideDate = tag.split("-").slice(-1)[0]), (adjustedCutoff = overrideDate), console.log(`customer tags used to change order cut-off date to ${overrideDate} for booking ref: ${reference}`));
    });
    let oneDayBefore = calculateEndDate(cutoff, -1),
        shoppingDate = new Date(changeDateOrder(adjustedCutoff)),
        finalContainer = document.createElement("div");
    finalContainer.classList.add("final-container");
    let cutoffContainerElement = document.createElement("div"),
        cutoffTitleElement = document.createElement("span");
    cutoffTitleElement.classList.add("title"), (cutoffTitleElement.textContent = "Last day to shop:");
    let cutoffElement = document.createElement("span");
    cutoffElement.textContent = `${formatDate(changeDateOrder(oneDayBefore))}`;
    let cutoffWarningElement = document.createElement("p");
    cutoffWarningElement.classList.add("cutoff-warning-text"), (cutoffWarningElement.textContent = "Please ensure your have completed checkout of your order before last day to shop.");
   var eGuideURL = '';
    if(location == 'Belize'){
    	eGuideURL = 'https://indd.adobe.com/view/cfa02f13-5d66-4e42-bd1c-ae57e46cdb6d';
    }else if(location == 'Exumas'){
    	eGuideURL = 'https://indd.adobe.com/view/d86dce13-46c2-4f3b-8415-e0a0c3083fbe';
    }else if(location == 'Abacos'){
    	eGuideURL = 'https://indd.adobe.com/view/a91a718b-9f77-4df1-9e42-28516d294ba8';
    }else if(location == 'La Paz'){
    	eGuideURL = '#';
    }else if(location == 'St. Martin'){
    	eGuideURL = 'https://indd.adobe.com/view/cf709f05-6b9a-4c78-a6ba-9a4bc236d1c0';
    }else if(location == 'St. Lucia'){
    	eGuideURL = 'https://indd.adobe.com/view/cf709f05-6b9a-4c78-a6ba-9a4bc236d1c0';
    }else if(location == 'British Virgin Islands'){
    	eGuideURL = 'http://indd.adobe.com/view/92fa2c12-6656-4003-bbbd-f615a146075a';
    }else if(location == 'Antigua'){
    	eGuideURL = 'https://indd.adobe.com/view/0b0304b9-8139-4cfb-8ce1-f5c8c18e5e7a';
    }else if(location == 'Seychelles'){
    	eGuideURL = 'https://indd.adobe.com/view/d7e314f4-3f7d-4aea-8982-6c401370ba94';
    }else if(location == 'Thailand'){
    	eGuideURL = 'https://indd.adobe.com/view/7f57f6aa-3bdd-4118-92be-6dfdf31d2747';
    }else if(location == 'Tahiti'){
    	eGuideURL = 'https://indd.adobe.com/view/0be3f0d4-5032-4a11-9b66-48bbdfdcffeb';
    }else if(location == 'Sardinia'){
    	eGuideURL = 'https://indd.adobe.com/view/87ee8c8e-1a23-4fa3-87cf-ec184cf4616f';
    }else if(location == 'Athens'){
    	eGuideURL = 'https://indd.adobe.com/view/336a4803-68d9-443d-bf51-fd0326837d11';
    }else if(location == 'Procida'){
    	eGuideURL = 'https://indd.adobe.com/view/45e7df6d-8ed5-4e57-94fc-e8ace7f28105';
    }else if(location == 'Agana'){
    	eGuideURL = 'https://indd.adobe.com/view/7b7acd57-c5d8-4144-9f5b-7fa6016a6ee6';
    }
    else if(location == 'Corfu'){
    	eGuideURL = 'https://indd.adobe.com/view/e246a672-d9ff-47e3-9de1-ce545bdc9b6c';
    }
    else if(location == 'Sicily'){
    	eGuideURL = 'https://indd.adobe.com/view/e6f1495e-4f6e-496c-8a0a-5ff1a0b802f5';
    }else if(location == 'Dubrovnik'){
    	eGuideURL = 'https://indd.adobe.com/view/3fdb3e26-e9a8-4ab4-ae65-78d953b64867';
    }else if(location == 'Portorosa, Sicily'){
        eGuideURL = 'https://indd.adobe.com/view/2084a31a-e9c9-4cf1-9d49-34a6ca8a127c';
    }else if(location == 'Phuket'){
        eGuideURL = 'https://indd.adobe.com/view/7f57f6aa-3bdd-4118-92be-6dfdf31d2747';
    }
    else{
    	eGuideURL = 'https://www.moorings.com/yacht-charter/submission';
    }
    let cutoffButtonElement = document.createElement("button");
    new Date() > shoppingDate
        ? ((cutoffTitleElement.textContent = "Shop closed on:"),
          (cutoffWarningElement.textContent = "View destination e-guide for alternative options to shop provisions."),
          cutoffButtonElement.classList.add("btn"),
          cutoffButtonElement.classList.add("product-add"),
          (cutoffButtonElement.textContent = "View e-guide"),
          (cutoffButtonElement.onclick = function () {
              window.open(eGuideURL, "_blank");
          }))
        : (cutoffButtonElement.classList.add("provision-button"),
          (cutoffButtonElement.textContent = "Select provisions"),
          (cutoffButtonElement.onclick = function () {
         
            localStorage.setItem('currentBase',locationCode);
   

        setTimeout(function () {
            try {
                console.log('Inside setTimeout');
                console.log('locationCode3:', locationCode);

                if (!startDate || !location || !reference || !guests || !numberOfDays || !cutoff || !locationCode) {
                    throw new Error("Missing variables");
                }

                const thisBooking = [
                    startDate, location, reference, guests, numberOfDays, cutoff, locationCode
                ].join(",");

                cutoffButtonElement.classList.add("active");
                cutoffButtonElement.innerHTML = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';

                window.travelopia.switchBooking(thisBooking);
            } catch (error) {
                console.error("Error inside setTimeout:", error);
            }
        }, 1000);
   
})),
        cutoffContainerElement.appendChild(cutoffTitleElement),
        cutoffContainerElement.appendChild(cutoffElement),
        finalContainer.appendChild(cutoffContainerElement),
        cutoffContainerElement.appendChild(cutoffWarningElement),
        finalContainer.appendChild(cutoffButtonElement),
        orderDiv.appendChild(finalContainer),
        orderContainer.appendChild(orderDiv);
}
function calculateEndDate(startDateStr, numberOfDays) {
    const [day, month, year] = startDateStr.split("/").map(Number),
        startDate = new Date(year, month - 1, day),
        endDate = new Date(startDate.getTime() + 24 * numberOfDays * 60 * 60 * 1e3),
        endDay = endDate.getDate(),
        endMonth = endDate.getMonth() + 1,
        endYear = endDate.getFullYear();
    return `${endDay.toString().padStart(2, "0")}/${endMonth.toString().padStart(2, "0")}/${endYear}`;
}
function changeDateToUSA(dateString) {
    const dateParts = dateString.split("/");
    if (3 !== dateParts.length) return "Invalid date format";
    return `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
}
function formatDate(inputDate) {
    const date = new Date(inputDate),
        day = date.getDate(),
        monthIndex = date.getMonth(),
        year = date.getFullYear();
    return `${day} ${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][monthIndex]} ${year}`;
}
document.addEventListener("DOMContentLoaded", (event) => {
    if (window.location.pathname === window.Shopify.routes.root || window.location.pathname.includes("account") || window.location.pathname.includes("/challenge")) return;
    const { activeCart, customerTags } = window.travelopia,
        dataArray = activeCart.split(",");
    let bookingCutOff = dataArray[5];
    const bookingReference = dataArray[2];
    let overrideDate = "",
        adjustedCutoff = bookingCutOff;
    customerTags.forEach((tag) => {
        tag.includes("Extend:") &&
            tag.includes(bookingReference) &&
            ((overrideDate = tag.split("-").slice(-1)[0]), (adjustedCutoff = overrideDate), console.log(`customer tags used to change order cut-off date to ${overrideDate} for booking ref: ${bookingReference}`));
    });
    const filteredPath = window.location.pathname.split("/").filter(function (el) {
        return "" != el;
    });
    new Date() > new Date(changeDateOrder(adjustedCutoff)) &&
        (("products" !== filteredPath[0] && "collections" !== filteredPath[0] && "search" !== filteredPath[0] && "cart" !== filteredPath[0]) || (window.location.href = window.Shopify.routes.root));
}),
    (window.travelopia = window.travelopia || {}),
    (window.travelopia = {
        ...window.travelopia,
        switchBooking: async function (thisBooking) {
            //current customer ID is needed to fetch metafields
            const customerID = $("#customerID").text().trim();
                
                let metafieldsData = {};
                let activeBooking = {};
                let cartSessions = {};
                let bundleCartSessions = {};

                //fetch metafields from shopify via middleware API
                  try {
                    const response = await fetch("https://c3eco6vbn1.execute-api.us-east-1.amazonaws.com/prod/mooringsbvi-customer-meta-fields?customerId=" + customerID, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" }
                    });
                    metafieldsData = await response.json();
                    activeBooking = metafieldsData.metafields?.active_cart?.value || "";
                    cartSessions = metafieldsData.metafields?.cart_sessions?.value || "{}";
                    current_carts = metafieldsData.metafields?.current_carts?.value || "{}";
                    bundleCartSessions = metafieldsData.metafields?.bundle_cart_sessions?.value || "{}";
                    } catch (err) {
                        console.log("Error fetching metafields:", err);
                    }

                 //Also extract booking data from the new booking (thisBooking)
                const { reference: thisReference, locationCode: thisLocationCode } = extractBookingData(thisBooking);
                
                //Parse existing cart sessions data if available
                let cartSessionsData = typeof cartSessions === "string" ? JSON.parse(cartSessions) : cartSessions;

                let bundleCartSessionsData = typeof bundleCartSessions === "string" ? JSON.parse(bundleCartSessions) : bundleCartSessions;

                //Save the current base locally
                localStorage.setItem('currentBase', thisLocationCode);


                // Helper function to update customer metafields via our Node.js endpoint
                async function updateCustomerMetafields(newActiveCart, newBase, newCartSessions, newBundleCartSessions) {
                    console.log('updateCustomerMetafields');
                    console.log(newActiveCart);
                    console.log(newCartSessions);
                    try {
                    const updateResponse = await fetch("https://c3eco6vbn1.execute-api.us-east-1.amazonaws.com/prod/mooringsbvi-customer-meta-fields?customerId=" + customerID, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                        customerId: customerID,
                        active_cart: newActiveCart,
                        current_base: newBase,
                        cart_sessions: JSON.stringify(newCartSessions),
                         bundle_cart_sessions: JSON.stringify(newBundleCartSessions)
                        })
                    });
                    const updateResult = await updateResponse.json();
                    console.log("Metafields update result:", updateResult);

                    } catch (err) {
                    console.log("Error updating metafields:", err);
                    }
                }



                if (activeBooking !== thisBooking) {
                    console.log('activeBooking !== thisBooking');
                    console.log('Switching to new booking: ' + thisBooking);
                    if (activeBooking) {
                    console.log('activeBooking');
                    localStorage.setItem('cartSync', '0');
                    // Extract active booking reference from the currently active booking
                    const { reference: activeReference } = extractBookingData(activeBooking);
                    try {
                        const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
                        const result = await cartRes.json();
                        // Ensure an object exists for the active booking reference
                        cartSessionsData[activeReference] = cartSessionsData[activeReference] || {};

                        cartSessionsData[activeReference].updates = {};

                                                    cartSessionsData[activeReference].updates = {};

                            bundleCartSessionsData[activeReference] = {
                                bundles: [],
                                timestamp: Date.now()
                            };

                            result.items.forEach((item) => {

                                const properties = item.properties || {};

                                const isMixMatchBundle =
                                    properties.__mix_match_bundle === "true";

                                if (isMixMatchBundle) {

                                    let addons = [];

                                    try {
                                        addons = JSON.parse(
                                            properties.__mix_match_addons || "[]"
                                        );
                                    } catch (error) {
                                        console.error(
                                            "Could not parse bundle addons:",
                                            error
                                        );
                                    }

                                    bundleCartSessionsData[activeReference].bundles.push({
                                        parent_variant_id: Number(item.variant_id),
                                        quantity: 1,
                                        package: properties.__mix_match_package || "",
                                        addons: addons
                                    });

                                    return;
                                }

                                cartSessionsData[activeReference].updates[item.variant_id] =
                                    item.quantity;
                            });
                    } catch (err) {
                        console.log("Error fetching current cart:", err);
                    }
                    }
                    console.log("Cart sessions for new booking:", cartSessionsData[thisReference]);

                    // 4. Clear the Shopify cart
                    try {
                    await fetch(window.Shopify.routes.root + "cart/clear.js", { method: "POST" });
                    } catch (err) {
                    console.log("Error clearing cart:", err);
                    }

                    // 5. After clearing the cart, re-fetch the cart items to create the itemsString
                    let itemsString = "";
                let partialUpdates = {};
                const MAX_URL_ITEMS = 230;

                try {
                const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
                const result = await cartRes.json();

                const updates = cartSessionsData[thisReference]?.updates || {};
                const updateEntries = Object.entries(updates);

                const urlEntries = updateEntries.slice(0, MAX_URL_ITEMS);
                const postEntries = updateEntries.slice(MAX_URL_ITEMS);

                itemsString = urlEntries
                    .map(([id, quantity]) => `${id}:${quantity}`)
                    .join(',');

                partialUpdates = Object.fromEntries(postEntries);

                console.log("URL items:", urlEntries.length);
                console.log("POST items:", postEntries.length);
                console.log("Items string:", itemsString);
                } catch (err) {
                console.log("Error fetching cart after clear:", err);
                }

                    setTimeout(async () => {

                        await updateCustomerMetafields(
                            thisBooking,
                            thisLocationCode,
                            cartSessionsData,
                            bundleCartSessionsData
                        );

                        // NEW BUNDLE LOGIC
                        const bundlesToRestore =
                            bundleCartSessionsData[thisReference]?.bundles || [];

                        if (bundlesToRestore.length > 0) {

                            sessionStorage.setItem(
                                "travelopiaPendingBundles",
                                JSON.stringify(bundlesToRestore)
                            );

                        } else {

                            sessionStorage.removeItem(
                                "travelopiaPendingBundles"
                            );
                        }

                        // EXISTING NORMAL CART LOGIC
                        if (itemsString) {

                            if (Object.keys(partialUpdates).length > 0) {
                                sessionStorage.setItem(
                                    "cartPartialUpdates",
                                    JSON.stringify(partialUpdates)
                                );
                            }

                            const redirectURL =
                                window.Shopify.routes.root +
                                "cart/" +
                                itemsString +
                                "?storefront=true";

                            localStorage.setItem("cartSync", "1");

                            window.location.href = redirectURL;

                        } else {

                            window.location.href =
                                "/collections/all-products/location-" +
                                thisLocationCode;
                        }

                    }, 3000);

                } else {

                    // Else branch: activeBooking is the same as thisBooking or activeBooking is empty.
                    if (!activeBooking) {
                    localStorage.setItem('cartSync', '0');
                    // (Optional) Use thisBooking as the active reference if no active booking exists.
                    const { reference: activeReference } = extractBookingData(thisBooking);
                    try {
                        const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
                        const result = await cartRes.json();
                        cartSessionsData[activeReference] = cartSessionsData[activeReference] || {};
                        cartSessionsData[activeReference].updates = {};
                        result.items.forEach((item) => {
                        cartSessionsData[activeReference].updates[item.variant_id] = item.quantity;
                        });
                    } catch (err) {
                        console.log("Error fetching current cart:", err);
                    }
                    }
                    console.log("Cart sessions for re-activation:", cartSessionsData[thisReference]);

                    // Clear the cart
                    try {
                    await fetch(window.Shopify.routes.root + "cart/clear.js", { method: "POST" });
                    } catch (err) {
                    console.log("Error clearing cart:", err);
                    }

                 // Get updated cart items string
                let itemsString = "";
                let partialUpdates = {};
                const MAX_URL_ITEMS = 230;

                try {
                const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
                const result = await cartRes.json();

                const updates = cartSessionsData[thisReference]?.updates || {};
                const updateEntries = Object.entries(updates);

                const urlEntries = updateEntries.slice(0, MAX_URL_ITEMS);
                const postEntries = updateEntries.slice(MAX_URL_ITEMS);

                itemsString = urlEntries
                    .map(([id, quantity]) => `${id}:${quantity}`)
                    .join(',');

                partialUpdates = Object.fromEntries(postEntries);
                } catch (err) {
                console.log("Error fetching cart after clear:", err);
                }

                    setTimeout(async () => {

                        await updateCustomerMetafields(
                            thisBooking,
                            thisLocationCode,
                            cartSessionsData,
                            bundleCartSessionsData
                        );

                        // NEW BUNDLE LOGIC
                        const bundlesToRestore =
                            bundleCartSessionsData[thisReference]?.bundles || [];

                        if (bundlesToRestore.length > 0) {

                            sessionStorage.setItem(
                                "travelopiaPendingBundles",
                                JSON.stringify(bundlesToRestore)
                            );

                        } else {

                            sessionStorage.removeItem(
                                "travelopiaPendingBundles"
                            );
                        }

                        // EXISTING NORMAL CART LOGIC
                        if (itemsString) {

                            if (Object.keys(partialUpdates).length > 0) {
                                sessionStorage.setItem(
                                    "cartPartialUpdates",
                                    JSON.stringify(partialUpdates)
                                );
                            }

                            const redirectURL =
                                window.Shopify.routes.root +
                                "cart/" +
                                itemsString +
                                "?storefront=true";

                            localStorage.setItem("cartSync", "1");

                            window.location.href = redirectURL;

                        } else {

                            window.location.href =
                                "/collections/all-products/location-" +
                                thisLocationCode;
                        }

                    }, 3000);
                                 }             
        },
        bookingSwitcherChange: function (event) {
            document.querySelector("#booking-switcher-overlay").classList.add("active");
            const dropdown = event.currentTarget,
                selectedOptionData = event.currentTarget.options[dropdown.selectedIndex].value;
            "add-new-booking" === selectedOptionData ? (window.location.href = window.Shopify.routes.root) : window.travelopia.switchBooking(selectedOptionData);
        },
    }),
    (window.travelopiaFunctions = window.travelopiaFunctions || {}),
    (window.travelopiaFunctions = {
        ...window.travelopia,
  renderOrdersSection: async function () {
  // Get the customer ID from the page (adjust the selector as needed)
  const customerId = $("#customerID").text().trim();

  // Variable to hold the fetched orders
  let currentOrders = "";

  // 1. Fetch the current_carts metafield from the Node.js server
  try {
    console.log(customerId);
const response = await fetch("https://c3eco6vbn1.execute-api.us-east-1.amazonaws.com/prod/mooringsbvi-customer-meta-fields?customerId=" + customerId, {
  method: "GET",
  headers: { "Content-Type": "application/json" }
});


    const data = await response.json();
    console.log(data);
    if (data.metafields.current_carts.id && data.metafields.current_carts.value) {
      // Store the fetched value in currentOrders
      currentOrders = data.metafields.current_carts.value;
    }
  } catch (error) {
    console.error("Error fetching metafields:", error);
  }

  // 2. Process and render the orders
  if (currentOrders !== "") {
    // Assume that orders are delimited by "|" (if not, adjust accordingly).
    // If no pipe delimiter is present, assume it's a single order.
    const ordersArray = currentOrders.includes("|") ? currentOrders.split("|") : [currentOrders];
    console.log('ordersArray');
    console.log(ordersArray);

    // Sort the orders based on the departure date (assumed to be the first field)
    const sortedBookings = ordersArray.toSorted((a, b) => {
      const aFields = a.split(",");
      const bFields = b.split(",");
      return (
        new Date(changeDateToUSA(bFields[0])).getTime() -
        new Date(changeDateToUSA(aFields[0])).getTime()
      );
    });

    // Clear the container before rendering orders
    document.querySelector("#existing-bookings-container").innerHTML = "";

    // Loop over each order and call addOrder with the 7 expected fields
    for (let order of sortedBookings) {
      // Split each order by comma to get its parts
      order = order.split(",");
      // Ensure there are at least 7 fields before calling addOrder
      if (order.length >= 7) {
        addOrder(order[0], order[1], order[2], order[3], order[4], order[5], order[6]);
      } else {
        console.warn("Incomplete order data:", order);
      }
    }
  } else {
    // If there are no orders, adjust the UI accordingly
    document.querySelector("#bookings-holding-section").style.height = "auto";
    document.querySelector("#bookings-holding-section").style.opacity = "1";
  }
},
    }),
    (window.onload = function () {
        const tritonForm = document.getElementById("bookingSearchForm");
        tritonForm && ((document.querySelector("#loading-spinner").style.display = "none"), window.travelopiaFunctions.renderOrdersSection(), tritonForm.addEventListener("submit", handleSubmit));
    });
    let throttledCall,
    currentConversionData = {};
    async function updateCustomerCarts() {
         // Only proceed if there is an active cart
        if (!window.travelopia.activeCart) return;

        try {
            // Fetch the current cart from Shopify
            const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
            const result = await cartResponse.json();

            // Get the current timestamp
            const timestamp = Date.now();

            // Build or retrieve the current customer cart sessions data
                let cartSessionsData =
                    window.travelopia.customerCartSessions || {};

                let bundleCartSessionsData =
                    window.travelopia.bundleCartSessions || {};

                const thisBookingRef =
                    window.travelopia.activeCart.split(",")[2];

                cartSessionsData[thisBookingRef] = {
                    updates: {},
                    timestamp: timestamp
                };

                bundleCartSessionsData[thisBookingRef] = {
                    bundles: [],
                    timestamp: timestamp
                };

                result.items.forEach((item) => {

                    const properties = item.properties || {};

                    const isMixMatchBundle =
                        properties.__mix_match_bundle === "true";

                    if (isMixMatchBundle) {

                        let addons = [];

                        try {
                            addons = JSON.parse(
                                properties.__mix_match_addons || "[]"
                            );
                        } catch (error) {
                            console.error(
                                "Could not parse bundle addons:",
                                error
                            );
                        }

                        bundleCartSessionsData[thisBookingRef].bundles.push({
                            parent_variant_id: Number(item.variant_id),
                            quantity: 1,
                            package: properties.__mix_match_package || "",
                            addons: addons
                        });

                        return;
                    }

                    cartSessionsData[thisBookingRef].updates[item.variant_id] =
                        item.quantity;
                });

            // Optionally, store the timestamp locally for reference
            localStorage.setItem("Travelopia_Cart_Timestamp", timestamp);

            // Retrieve the customer ID from the page
            const customerID = $("#customerID").text().trim();

            // Instead of using CF.customer.set() and CF.customer.save(), 
            // use the Node.js endpoint to update the metafield "cart_sessions".
            const response = await fetch("https://c3eco6vbn1.execute-api.us-east-1.amazonaws.com/prod/mooringsbvi-customer-meta-fields?customerId=" + customerID, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                customerId: customerID,
                cart_sessions: JSON.stringify(cartSessionsData),
                bundle_cart_sessions: JSON.stringify(bundleCartSessionsData)
            })
            });

            const updateData = await response.json();

            console.log('updateData');
            console.log(updateData);

            if (updateData.updatedMetafields || updateData.newMetafields) {
            console.log("Customer cart sessions saved successfully:", updateData);
            window.travelopia.customerCartSessions = cartSessionsData;
            window.travelopia.bundleCartSessions = bundleCartSessionsData;
            } else {
            console.error("Cart session data not saved:", updateData.error);
            }
        } catch (err) {
            console.log("There was an error attempting to fetch the current cart or update metafields", err);
        }
        }
async function clearCart() {
    await fetch(window.Shopify.routes.root + "cart/clear.js", { method: "POST" })
        .then((res) => res.json())
        .then((result) => {
            document.dispatchEvent(new CustomEvent("cart:updated")), theme.updateCartSummaries();
        })
        .catch((err) => console.log("there was an error attempting to update cart", err));
}
addEventListener("DOMContentLoaded", async (event) => {
    const targetNode = document.querySelector('div[data-section-type="cart-drawer"]') || document.querySelector(".cart-subtotal");
    if (!targetNode) return;
    new MutationObserver((mutationList, observer2) => {
        const moneyEl = document.querySelector(".money.buckscc-converted.buckscc-money");
        if (!moneyEl) return;
        const scrappedValues = { currency: moneyEl.attributes["bucks-currency"].value || void 0, cartConverted: moneyEl.attributes["bucks-current"].value || void 0, cartTotal: moneyEl.attributes["bucks-original"].value || void 0 };
        (function isEqual(a, b) {
            return JSON.stringify(a) === JSON.stringify(b);
        })(scrappedValues, currentConversionData) ||
            ((currentConversionData = { ...scrappedValues }),
            (function showConvertedCurrency({ cartConverted, cartTotal, currency }) {
                const existingNote = document.querySelector("#sp-conversions-note");
                if ((existingNote && existingNote.remove(), "USD" === currency)) return;
                const conversionNote = `<div id="sp-conversions-note">\n  <p>${window.travelopia.cartConversionNote}</p>\n  <h6><span>${cartConverted}</span>&nbsp;=&nbsp;<span>${cartTotal}</span></h6>\n  </div>`,
                    targetElement = document.querySelector(".cart-summary__buttons.cart-summary__section") || document.querySelector(".cart-footer");
                document.querySelector(".cart-summary__buttons.cart-summary__section")
                    ? (targetElement.innerHTML += conversionNote)
                    : document.querySelector(".cart-footer") && (targetElement.innerHTML = conversionNote + targetElement.innerHTML);
            })(scrappedValues));
    }).observe(targetNode, { attributes: !0, childList: !0, subtree: !0 });
}),
    document.addEventListener("DOMContentLoaded", async (event) => {
        const qtyAdjustButtons = document.querySelectorAll("[data-qty-adjust]");
        qtyAdjustButtons.length > 0 &&
            qtyAdjustButtons.forEach((button) => {
                button.addEventListener("click", (event2) => {
                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent("cart:updated"));
                    }, 200);
                });
            }),
            document.addEventListener("cart:updated", function () {
                console.log('cart:updated');
                throttledCall ||
                    (throttledCall = (function throttle(func, wait, options) {
                        var context,
                            args,
                            result,
                            timeout = null,
                            previous = 0;
                        options || (options = {});
                        var later = function () {
                            (previous = !1 === options.leading ? 0 : Date.now()), (timeout = null), (result = func.apply(context, args)), timeout || (context = args = null);
                        };
                        return function () {
                            var now = Date.now();
                            previous || !1 !== options.leading || (previous = now);
                            var remaining = wait - (now - previous);
                            return (
                                (context = this),
                                (args = arguments),
                                remaining <= 0 || remaining > wait
                                    ? (timeout && (clearTimeout(timeout), (timeout = null)), (previous = now), (result = func.apply(context, args)), timeout || (context = args = null))
                                    : timeout || !1 === options.trailing || (timeout = setTimeout(later, remaining)),
                                result
                            );
                        };
                    })(updateCustomerCarts, 4e3)),
                    throttledCall();
            })
    }),
    addEventListener("DOMContentLoaded", (event) => {
        const clearCartButton = document.querySelector("[data-clear-cart]");
        clearCartButton &&
            (clearCartButton.addEventListener("click", async () => {
                await clearCart();
            }),
            document.addEventListener("cart:updated", async () => {
                let newClearCartButton = document.querySelector("[data-clear-cart]");
                newClearCartButton &&
                    newClearCartButton.addEventListener("click", async () => {
                        await clearCart();
                    });
            }));
    });


if (window.location.pathname.includes('/cart') && localStorage.getItem('cartSync') === '1') {

    console.log('cartSync1');
  // Get the currentBase value from local storage
  const currentBase = localStorage.getItem('currentBase')?.toLowerCase();
console.log(currentBase);
  if (currentBase) {
    // Redirect the user to '/collections/all-products/' + currentBase
    window.location.href = '/collections/all-products/location-' + currentBase;

    // Set cartSync to 2 in local storage
    localStorage.setItem('cartSync', '2');
  } else {
    console.warn('currentBase not found in local storage');
  }
}


document.addEventListener("click", async function (e) {
  // Step 1: Handle Delete Button Click
   const deleteBtn = e.target.closest(".delete-booking");
  if (deleteBtn) {
    e.preventDefault();
    // Remove any existing popup first
    document.querySelector(".delete-confirmation-modal")?.remove();
    const modal = document.createElement("div");
    modal.className = "delete-confirmation-modal";
    modal.innerHTML = `
      <div class="delete-modal-content">
        <p class="title">Remove this booking?</p>
        <p class="subtitle">This will remove the booking from your list. You can add it back later if needed.</p>
        <div class="delete-modal-buttons">
          <button class="btn-cancel-delete">Cancel</button>
          <button class="btn-confirm-delete">Remove</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    const bookingDiv = e.target.closest(".customer-order");
   const reference = bookingDiv.getAttribute('data-reference').trim();
    const customerId = $("#customerID").text().trim();
    console.log('reference');
    console.log(reference);

    // Step 2: Attach Handlers
    modal.querySelector(".btn-cancel-delete").onclick = () => modal.remove();
    modal.querySelector(".btn-confirm-delete").onclick = async () => {
      modal.remove();
      try {
        const response = await fetch("https://c3eco6vbn1.execute-api.us-east-1.amazonaws.com/prod/mooringsbvi-customer-meta-fields?customerId=" + customerId, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" }
                    });
        const data = await response.json();
        let currentCartsRaw = data.metafields.cart_sessions.value || "{}";
        let currentCarts = data.metafields.current_carts.value || "";
        let activeCart = data.metafields.active_cart?.value || "";
        let currentBase = data.metafields.current_base?.value || "";
                 let bundleCartsRaw = data.metafields.bundle_cart_sessions?.value || "{}";

                  // sanitize: extract first JSON object/array substring between first { and last }
          function extractJsonString(s) {
            if (!s || typeof s !== 'string') return "{}";
            const first = s.indexOf('{');
            const last = s.lastIndexOf('}');
            if (first === -1 || last === -1 || last < first) return "{}";
            return s.slice(first, last + 1);
          }
          let sanitized = extractJsonString(currentCartsRaw);
          let newCartSessions;
           let newBundleCartSessions;
          try {
            newCartSessions = JSON.parse(sanitized);
          } catch (err) {
            console.error('Failed to parse current_carts:', err, sanitized);
            newCartSessions = {};
          }
                    
                try {
            newBundleCartSessions =
                typeof bundleCartsRaw === "string"
                    ? JSON.parse(bundleCartsRaw)
                    : bundleCartsRaw;
        } catch (err) {
            console.error(
                "Failed to parse bundle_cart_sessions:",
                err
            );

            newBundleCartSessions = {};
        }

        const filteredCarts = currentCarts
          .split("|")
          .filter(entry => {
            const parts = entry.split(",");
            const entryReference = parts[2]?.trim();
            return entryReference !== reference.trim();
          })
          .join("|");
          if (Object.prototype.hasOwnProperty.call(newCartSessions, reference)) {
            delete newCartSessions[reference];
            console.log(`Removed booking ${reference} from cart_sessions`);
          } else {
            console.warn('Reference not found in cart_sessions:', reference);
          }

          
                    if (
                Object.prototype.hasOwnProperty.call(
                    newBundleCartSessions,
                    reference
                )
            ) {
                delete newBundleCartSessions[reference];
            }




        if (!currentCarts.includes(reference)) currentBase = "";
        console.log('newCartSessions' + newCartSessions);
      console.log('current keys after delete:', Object.keys(newCartSessions));
      console.log('newCartSessions object:', newCartSessions);
      const payloadCartSessions = Object.keys(newCartSessions).length ? JSON.stringify(newCartSessions) : "{}";
        const bodyPayload = {
          customerId,
          active_cart: activeCart,
          current_base: currentBase,
          current_carts: filteredCarts === "" ? "{}" : filteredCarts,
          cart_sessions: payloadCartSessions,
           bundle_cart_sessions: JSON.stringify(newBundleCartSessions)
        };
        const updateResponse = await fetch("https://c3eco6vbn1.execute-api.us-east-1.amazonaws.com/prod/mooringsbvi-customer-meta-fields?customerId=" + customerId, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyPayload)
        });
        location.reload();
      } catch (error) {
        console.error("Delete error:", error);
      location.reload();
      }
    };
  }
});


document.addEventListener("DOMContentLoaded", async function () {

    const pendingBundlesRaw =
        sessionStorage.getItem("travelopiaPendingBundles");

    if (!pendingBundlesRaw) return;

    let pendingBundles = [];

    try {
        pendingBundles = JSON.parse(pendingBundlesRaw);
    } catch (error) {
        console.error(
            "Could not parse pending bundles:",
            error
        );

        sessionStorage.removeItem(
            "travelopiaPendingBundles"
        );

        return;
    }

    if (!Array.isArray(pendingBundles) ||
        pendingBundles.length === 0) {

        sessionStorage.removeItem(
            "travelopiaPendingBundles"
        );

        return;
    }

    /*
     * Remove BEFORE adding.
     * Prevents accidental duplicate restore if page reloads.
     */
    sessionStorage.removeItem(
        "travelopiaPendingBundles"
    );

    for (const bundle of pendingBundles) {

        try {

            const response = await fetch(
                window.Shopify.routes.root + "cart/add.js",
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({
                        id: Number(bundle.parent_variant_id),

                        /*
                         * Bundle wrapper is ALWAYS one cart line.
                         */
                        quantity: 1,

                        properties: {
                            __mix_match_bundle: "true",

                            __mix_match_package:
                                bundle.package || "",

                            __mix_match_addons:
                                JSON.stringify(
                                    bundle.addons || []
                                )
                        }
                    })
                }
            );

            if (!response.ok) {
                console.error(
                    "Bundle restore failed:",
                    await response.text()
                );
            }

        } catch (error) {

            console.error(
                "Error restoring bundle:",
                error
            );
        }
    }

    if (
        window.theme &&
        typeof window.theme.updateCartSummaries === "function"
    ) {
        window.theme.updateCartSummaries();
    }

});
